
import './App.css';
import { Outlet } from "react-router-dom";
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { MobileMenu } from './components/MobileMenu';
import { Govideo } from './components/Govideo';
import { HeaderOther } from './components/HeaderOther';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import "./css/mouse-helper.css"
import "./css/mouse-helper.responsive.css"
import "./css/mouse-helper.scss"
import "./css/mouse-helper.responsive.scss"
function App() {
  const location = useLocation();
  const path = location.pathname;
 useEffect(() => {
    // Clear old classes first
    document.body.className = "";

    if (path === "/") {
      document.body.classList.add(
        "home",
        "wp-singular",
        "page-template-default",
        "page",
        "page-id-18013",
        "wp-custom-logo",
        "wp-embed-responsive",
        "wp-theme-agricola",
        "theme-agricola",
        "frontpage",
        "woocommerce-js",
        "tinvwl-theme-style",
        "skin_default",
        "scheme_light",
        "blog_mode_front",
        "body_style_wide",
        "is_stream",
        "blog_style_excerpt",
        "sidebar_hide",
        "expand_content",
        "remove_margins",
        "trx_addons_present",
        "header_type_custom",
        "header_style_header-custom-18650",
        "header_position_over",
        "menu_side_none",
        "no_layout",
        "fixed_blocks_sticky",
        "elementor-default",
        "elementor-kit-15",
        "elementor-page",
        "elementor-page-18013",
        "blog",
        "e--ua-blink",
        "e--ua-chrome",
        "e--ua-webkit",
        "ua_blink",
        "ua_webkit",
        "ua_chrome",
        "animate_to_inited",
        "added_to_cart_inited"
      );
    } else if (path.startsWith("/blog")) {
      document.body.classList.add(
        "wp-singular",
        "page-template-default",
        "page",
        "page-id-17910",
        "wp-custom-logo",
        "wp-embed-responsive",
        "wp-theme-agricola",
        "theme-agricola",
        "woocommerce-js",
        "tinvwl-theme-style",
        "skin_default",
        "scheme_default",
        "blog_mode_page",
        "body_style_wide",
        "is_single",
        "sidebar_hide",
        "expand_content",
        "remove_margins",
        "trx_addons_present",
        "header_type_custom",
        "header_style_header-custom-18617",
        "header_position_default",
        "menu_side_none",
        "fixed_blocks_sticky",
        "elementor-default",
        "elementor-kit-15",
        "elementor-page",
        "elementor-page-17910",
        "e--ua-blink",
        "e--ua-chrome",
        "e--ua-webkit",
        "ua_blink",
        "ua_webkit",
        "ua_chrome",
        "animate_to_inited",
        "added_to_cart_inited",
        "desktop_layout"
      );
    } else if (path.startsWith("/products")) {
      document.body.classList.add(
        "wp-singular",
        "page-template-default",
        "page",
        "page-id-17910",
        "wp-custom-logo",
        "wp-embed-responsive",
        "wp-theme-agricola",
        "theme-agricola",
        "woocommerce-js",
        "tinvwl-theme-style",
        "skin_default",
        "scheme_default",
        "blog_mode_page",
        "body_style_wide",
        "is_single",
        "sidebar_hide",
        "expand_content",
        "remove_margins",
        "trx_addons_present",
        "header_type_custom",
        "header_style_header-custom-18617",
        "header_position_default",
        "menu_side_none",
        "fixed_blocks_sticky",
        "elementor-default",
        "elementor-kit-15",
        "elementor-page",
        "elementor-page-17910",
        "e--ua-blink",
        "e--ua-chrome",
        "e--ua-webkit",
        "ua_blink",
        "ua_webkit",
        "ua_chrome",
        "animate_to_inited",
        "added_to_cart_inited",
        "desktop_layout"
      );
    }
  }, [path]); 
    useEffect(() => {
    // Initialize mouse helper targets after component mount
    const initMouseHelperTargets = () => {
      const targets = document.querySelectorAll('[data-mouse-helper]');
      const magnets = document.querySelectorAll('[data-mouse-helper-magnet]:not([data-mouse-helper-magnet="0"])');
      
      // You can store these references if needed
      console.log('Mouse helper targets initialized:', targets.length);
    };

    // Simulate the document ready event
    const timer = setTimeout(initMouseHelperTargets, 100);
    
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <div className="body_wrap">
        <div className="page_wrap">
   
   
          {path === "/" ? <Header /> : <HeaderOther />}

          <div className="menu_mobile_overlay scheme_dark" />
          <MobileMenu />
          <Outlet />
          <a
            id="footer_skip_link_anchor"
            className="agricola_skip_link_anchor"
            href="#"
          />
          <Footer />

        </div>
      </div>
      <Govideo />
      <a
        href="#"
        className="trx_addons_scroll_to_top trx_addons_icon-up scroll_to_top_style_default" style={{background:"#401E15",color:"#FFFFFF"}}
        title="Scroll to top"
      >
        <i className="fa-solid fa-arrow-up"></i>
        </a>
    </>

  );
}

export default App;
